<template>
  <div class="menu_list">
    <!--    收藏菜单-->
    <div v-if="item.isFavMenu" id="fav-menu_box">
      <template v-if="favoriteMenus.length > 0">
        <div class="fav-item">
          <el-checkbox v-model="menuTopDisplayed" style="color: #666666" @change="showTips">开启常用菜单顶部展示</el-checkbox>
        </div>
        <div class="line" style="margin-bottom: 10px; width: 200px"></div>
      </template>
      <div id="fav-item_box">
        <div v-for="itemx in favoriteMenus" :key="itemx.id">
          <div class="item menu-item" @click="itemClick(itemx)">
            {{ itemx.name }}
            <i v-if="!favoriteMenusIds().includes(itemx.id)" class="icon-fav iconfont" @click.stop="favoriteIt(itemx)"></i>
            <i v-else class="icon-favoured iconfont" @click.stop="cancelFavoriteIt(itemx)"></i>
          </div>
        </div>
      </div>
    </div>
    <!--    正常菜单-->
    <template v-else>
      <div
        class="item"
        :class="menuTypeClass(item)"
        :style="{ marginTop: !justShowHeader && level === 0 ? '0px' : '', marginBottom: !justShowHeader && level === 0 ? '0px' : '' }"
        @click="itemClick(item)"
      >
        <template v-if="justShowHeader && level === 0">
          <span class="mark"></span>
          {{ item.name }}
        </template>
        <template v-else-if="!justShowHeader && level !== 0">{{ item.name }}</template>
        <template v-if="item.url && !item.list.length && level != 0">
          <i v-if="!favoriteMenusIds().includes(item.id)" class="icon-fav iconfont" @click.stop="favoriteIt(item)"></i>
          <i v-else class="icon-favoured iconfont" @click.stop="cancelFavoriteIt(item)"></i>
        </template>
      </div>
      <template v-if="item.list && item.list.length > 0 && !justShowHeader">
        <template v-for="(itemx, index) in item.list">
          <div :key="itemx.name" class="item" :class="menuTypeClass2(itemx)" @click="itemClick(itemx)">
            {{ itemx.name }}
            <template v-if="itemx.url && !itemx.list.length">
              <i v-if="!favoriteMenusIds().includes(itemx.id)" class="icon-fav iconfont" @click.stop="favoriteIt(itemx)"></i>
              <i v-else class="icon-favoured iconfont" @click.stop="cancelFavoriteIt(itemx)"></i>
            </template>
          </div>
          <SecondIndex
            v-for="child in itemx.list"
            :key="child.id"
            :item="child"
            :level="level + 1"
            :deep-children="true"
            :sys-belong="sysBelong"
            @item-click="itemClick"
          />
          <!-- 下划线 -->
          <div v-show="index + 1 !== item.list.length" v-if="passTitle(itemx)" :key="itemx.id" class="line"></div>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import SecondIndex from "@/layout/components/NewSiderSecond/SidebarItem/second-index.vue"
import Sortable from "sortablejs"
import {
  userCollectMenu,
  userCollectMenuDel,
  collectMenuUpdateSort,
  apiUserGeneralSettingsFind,
  apiUserGeneralSettingsUpdateByUserId
} from "@/api/user"
import { mapActions, mapState } from "vuex"

export default {
  name: "SecondIndex",
  components: { SecondIndex },
  props: {
    justShowHeader: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    sysBelong: {
      type: String,
      default: ""
    },
    level: {
      type: Number,
      default: 0
    },
    deepChildren: {
      type: Boolean,
      default: false
    },
    menuPopUpMethod: {
      type: String,
      default: "MOUSE_CLICK"
    },
    menuTopDisplayed: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isSubMenuOpen: true,
      checked: false
      // menuTopDisplayed: undefined,
      // menuPopUpMethod: undefined
    }
  },
  computed: {
    ...mapState("user", ["favoriteMenus"]),
    ...mapState("tagsView", ["favTopShow"])
  },
  watch: {
    "item.isFavMenu": {
      handler(n) {
        if (n) {
          this.$nextTick(() => {
            this.sortableFn()
          })
        }
      },
      immediate: true
    },
    favTopShow: {
      // handler(n) {
      //   this.checked = !!this.favTopShow
      // },
      // immediate: true
    },
    favoriteMenus: {
      handler(n) {
        // 当常用菜单数量为0并且是勾选状态时，则不再展示顶部，并设置为空
        if (this.favoriteMenus.length === 0 && this.menuTopDisplayed) {
          this.$store.commit("tagsView/CHANGE_FAVTOPSHOW", "")
          location.reload()
        }
      }
    }
  },
  created() {
    // this.getUserGeneralSettingsFind()
  },
  methods: {
    ...mapActions("user", ["getFavorite"]),
    // 获取通用设置
    async getUserGeneralSettingsFind() {
      const { code, data = {} } = await apiUserGeneralSettingsFind()
      if (code != 0) return
      this.menuTopDisplayed = !!data.menuTopDisplayed ?? localStorage.getItem("favTopShow") == "true"
      this.menuPopUpMethod = data.menuPopUpMethod ?? "MOUSE_CLICK"
    },
    // 更新通用设置
    async updateUserGenera(status) {
      const { code } = await apiUserGeneralSettingsUpdateByUserId({
        menuTopDisplayed: status,
        menuPopUpMethod: this.menuPopUpMethod
      })
      if (code != 0) return
      this.menuTopDisplayed = status
      if (status) {
        this.$store.commit("tagsView/CHANGE_FAVTOPSHOW", "true")
      } else {
        this.$store.commit("tagsView/CHANGE_FAVTOPSHOW", "")
      }
      this.$router.go(0)
    },
    // 收藏菜单下方的 是否勾选
    showTips() {
      this.$confirm(`${this.menuTopDisplayed ? "开启" : "关闭"}常用菜单顶部展示，需刷新页面后生效，是否立即刷新？`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.updateUserGenera(this.menuTopDisplayed)
          // if (this.menuTopDisplayed) {
          //   this.$store.commit("tagsView/CHANGE_FAVTOPSHOW", "true")
          // } else {
          //   this.$store.commit("tagsView/CHANGE_FAVTOPSHOW", "")
          // }
          // location.reload()
        })
        .catch(() => {
          this.menuTopDisplayed = !!this.favTopShow
        })
    },
    // 收藏拖拽
    sortableFn() {
      Sortable.create(document.getElementById("fav-item_box"), {
        animation: 50,
        onEnd: ({ newIndex, oldIndex }) => {
          const currRow = this.favoriteMenus.splice(oldIndex, 1)
          this.favoriteMenus.splice(newIndex, 0, currRow[0])
          for (let i = 0; i < this.favoriteMenus.length; i++) {
            const item = this.favoriteMenus[i]
            if (item) {
              item.menuId = item.id || ""
              item.orderNum = i
            } else {
              this.favoriteMenus.splice(i, 1)
              i--
            }
          }
          collectMenuUpdateSort({ list: this.favoriteMenus })
        }
      })
    },
    menuTypeClass(item) {
      // 如果是第一层菜单，则是带蓝色块的菜单
      if (this.level === 0 && item.list && (item.list.length > 0 || item.list.length === 0)) {
        return "big-title"
      }
      // 如果有子菜单
      if (item.list && item.list.length > 0) {
        return "small-title"
      }
      // 没有子菜单，非第一级的
      if (!item.list) {
        return "menu-item"
      }
      return "menu-item"
    },
    menuTypeClass2(item) {
      if (this.level === 0 && item.list && item.list.length > 0 && !item.url) {
        return "small-title2"
      }
      // 如果有子菜单
      if (item.list && item.list.length > 0) {
        return "small-title"
      }
      // 没有子菜单，非第一级的
      if (!item.list) {
        return "menu-item"
      }
      return "menu-item"
    },
    // 排除二级头的底线
    passTitle(item) {
      return !(this.level === 0 && !item.url && item.list && item.list.length > 0 && item.list[0].list && item.list[0].list.length > 0)
    },
    // 返回收藏菜单id集合
    favoriteMenusIds() {
      return this.favoriteMenus.map(item => item.id)
    },
    // 收藏菜单
    favoriteIt(item) {
      userCollectMenu({ menuId: item.id }).then(res => {
        // 重新获取收藏菜单
        this.getFavorite()
      })
    },
    // 取消收藏
    cancelFavoriteIt(item) {
      userCollectMenuDel({ menuId: item.id }).then(res => {
        // 重新获取收藏菜单
        this.getFavorite()
      })
    },
    toggleSubMenu() {
      if (this.item.list) {
        this.isSubMenuOpen = !this.isSubMenuOpen
      } else {
        this.$emit("item-click", this.item)
        // this.$bus.$emit("sidebarItemClick", this.item) // 点击叶子节点时触发事件
      }
    },
    // 点击菜单
    itemClick(item) {
      if (!this.item.isFavMenu) {
        if (item.list && item.list.length > 0) {
          return
        }
      } else {
        // 收藏菜单，单独处理下数据
        item.bfList = item.list
      }
      this.$emit("item-click", item)
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-message-box__status {
  margin-top: -12px;
}
.menu_list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 150px;
  flex-shrink: 0;
  .line {
    width: 150px;
    height: 1px;
    background: rgba(52, 60, 60, 0.1);
    border-radius: 0px 0px 0px 0px;
  }
  .item,
  .fav-item {
    width: 100%;
    margin-left: 10px;
    padding: 10px 0 14px 0;
    font-size: 13px;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .mark {
      display: inline-block;
      width: 3px;
      height: 16px;
      background: #3296fa;
      border-radius: 2px 2px 2px 2px;
      margin-right: 8px;
      position: relative;
    }
  }
  .menu-item {
    cursor: pointer;
  }
  .menu-item:hover {
    color: #2d8cf0;
  }
  .big-title {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 15px;
    margin-left: 0px;
    margin-top: 20px;
    padding: 0;
    justify-content: flex-start;
  }
  .small-title2 {
    font-size: 15px;
    font-weight: 700;
  }
  .small-title {
    font-weight: 700;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
}
.icon-favoured {
  font-size: 12px;
  color: #faad14;
  margin-right: 10px;
}
.icon-fav {
  font-size: 12px;
  color: #999999;
  margin-right: 10px;
  display: none;
}
.item:hover .icon-fav {
  display: block;
}
#fav-item_box {
  height: calc(100vh - 150px);
  overflow-y: scroll;
  padding-right: 20px;
}
</style>
